import type { PensionAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { convertCurrency } from "../genericCalculations/convertCurrency";
import { calculateOwnership } from "../genericCalculations/ownership";

export const pensionBalance = (userProduct: PensionAsset) => {
  const balance = userProduct?.amount || 0;
  const ownership = 100;

  return calculateOwnership(balance, ownership);
};

export const convertPensionBalance = (
  userProduct: PensionAsset,
  currencies: { baseCurrency: Fiat; currentCurrency: Fiat }
) => {
  const { baseCurrency, currentCurrency } = currencies;
  const balance = pensionBalance(userProduct);

  return convertCurrency(balance, baseCurrency, currentCurrency);
};
